// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WtgX8{margin-bottom:16px}.Cl6HG{list-style:disc;padding-inline-start:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requestAccAccessParagraph": `WtgX8`,
	"requestAccAccessList": `Cl6HG`
};
export default ___CSS_LOADER_EXPORT___;
